import { useMemo } from "react";

import { CodeBrowser, GridTilesMasonry, Package, Stack } from "components/icons/generated";

import {
  MAIN_NAVIGATION_PRIMARY_MENU_ITEMS,
  MainNavigationPrimaryMenuItemKeys,
} from "../config/menuItemsPrimary";
import { MainNavigationMobileItem } from "../types";

const useMainNavigationMobileMenuItems = (): MainNavigationMobileItem[] => {
  return useMemo(() => {
    return [
      {
        ...MAIN_NAVIGATION_PRIMARY_MENU_ITEMS[MainNavigationPrimaryMenuItemKeys.Dashboard],
        icon: GridTilesMasonry,
      },

      {
        ...MAIN_NAVIGATION_PRIMARY_MENU_ITEMS[MainNavigationPrimaryMenuItemKeys.Stacks],
        icon: Stack,
      },
      {
        ...MAIN_NAVIGATION_PRIMARY_MENU_ITEMS[MainNavigationPrimaryMenuItemKeys.Blueprints],
        icon: CodeBrowser,
      },
      {
        ...MAIN_NAVIGATION_PRIMARY_MENU_ITEMS[MainNavigationPrimaryMenuItemKeys.Registry],
        icon: Package,
      },
    ];
  }, []);
};

export default useMainNavigationMobileMenuItems;
